import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#dc143c', // Crimson red from the site
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#1a1a1a', // Dark black
      contrastText: '#ffffff',
    },
    background: {
      default: '#ffffff',
      paper: '#1a1a1a',
    },
    text: {
      primary: '#1a1a1a',
      secondary: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Arial Black", "Impact", "Helvetica Neue", Arial, sans-serif',
    h1: {
      fontFamily: '"Impact", "Arial Black", sans-serif',
      fontWeight: 900,
      fontSize: '4rem',
      lineHeight: 1.1,
      textTransform: 'uppercase',
      letterSpacing: '-0.02em',
      '@media (max-width:600px)': {
        fontSize: '2.5rem',
      },
    },
    h2: {
      fontFamily: '"Impact", "Arial Black", sans-serif',
      fontWeight: 900,
      fontSize: '3rem',
      lineHeight: 1.2,
      textTransform: 'uppercase',
      letterSpacing: '-0.01em',
      '@media (max-width:600px)': {
        fontSize: '2rem',
      },
    },
    h3: {
      fontFamily: '"Impact", "Arial Black", sans-serif',
      fontWeight: 900,
      fontSize: '2rem',
      lineHeight: 1.3,
      textTransform: 'uppercase',
      '@media (max-width:600px)': {
        fontSize: '1.5rem',
      },
    },
    h4: {
      fontFamily: '"Arial", sans-serif',
      fontWeight: 400,
      fontSize: '1.25rem',
      lineHeight: 1.5,
    },
    body1: {
      fontFamily: '"Arial", sans-serif',
      fontSize: '1.125rem',
      lineHeight: 1.7,
      fontWeight: 400,
    },
    body2: {
      fontFamily: '"Arial", sans-serif',
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    button: {
      fontFamily: '"Arial Black", sans-serif',
      fontWeight: 700,
      textTransform: 'none',
      fontSize: '1rem',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          padding: '12px 32px',
          fontSize: '1rem',
          fontWeight: 700,
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          '@media (min-width:1200px)': {
            maxWidth: '1200px',
          },
        },
      },
    },
  },
});

export default theme;